export default __webpack_public_path__ + "static/page-header-do-1-856ed4e8da7626e8ec66df97f0e26ea301c9d4e391d13540e32a4bf9fd96eb6d.png";